import { useEffect, useState } from "react"
import { actions } from "../../data/actions"
import { GET_GQL_SCHEMA } from "../../data/actionTypes"
import { __, jsonToData } from "src/libs/utilities"
import ReactJsonView from '@microlink/react-json-view'
import { Button, Collapse } from "@blueprintjs/core"
import { schema } from "src/libs/layouts"

/* Protopia Ecosystem component */
export interface IUtilitiesFormsProps {
   
}
const UtilitiesForms = (props: IUtilitiesFormsProps): JSX.Element => {
    const [isLoading, setIsLoading] = useState<boolean>( false )
    const [isShowSchema, setIsShowSchema] = useState<boolean>( false )
    const [gql, setGql] = useState<any>( {} )
    useEffect(() => {
        
    }, [])
    const loadData = () => {
        setIsLoading(true)
        actions(GET_GQL_SCHEMA, {})
            .then((response) => {
                setIsLoading(false)
                console.log( response )
                setGql( jsonToData(response) )
            })
    }
    return <div className='pe-utilities-forms-container'>
        {/* <Button fill size="large" intent="primary" onClick={ loadData } loading={isLoading}>
            { __("Load GQL Schema") }
        </Button>
        <Collapse isOpen={ !!Object.keys(gql).length }>
            <ReactJsonView 
                src={gql}  
                displayObjectSize 
                displayDataTypes={false}
                collapsed={true}
                indentWidth={2}
                collapseStringsAfterLength={20}
                quotesOnKeys={false}
            />
        </Collapse> */}
        <Button fill size="large" intent="primary" onClick={ () => setIsShowSchema(!isLoading) } >
            { __("Load Schema") }
        </Button>
        <Collapse isOpen={ !!isShowSchema }>
            <ReactJsonView 
                src={ (schema() || {}) }  
                displayObjectSize 
                displayDataTypes={false}
                collapsed={true}
                indentWidth={2}
                collapseStringsAfterLength={20}
                quotesOnKeys={false}
            />
        </Collapse>
    </div>
}
export default UtilitiesForms